import React from "react"
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer"
import Nav from "./Nav"

const AppDropdownMenu = ({ toggleDrawer, open }) => {
  return (
    <SwipeableDrawer
      anchor="right"
      open={open}
      onClose={toggleDrawer}
      onOpen={toggleDrawer}
    >
      <Nav dropdown toggleDrawer={toggleDrawer} />
    </SwipeableDrawer>
  )
}

export default AppDropdownMenu
